import "./apiUrls-2n3hzoxF.js";
//#region src/generated/types.gen.ts
var e = {
	ACCESS_DENIED: 3e3,
	PERMISSION_DENIED: 3001,
	SESSION_TOKEN_NOT_FOUND: 3002,
	LAST_LOGIN_ATTEMPT_FAILED: 3003,
	MAX_LOGIN_ATTEMPTS_REACHED: 3004,
	SESSION_TOKEN_INVALIDATED: 3005,
	INVALID_JWT_TOKEN: 3006,
	USER_NOT_FOUND_IN_AUTHCONTEXT: 3007
}, t = { 404: 404 }, n = {
	STANDARD: 1,
	RETURN: 2,
	MULTI_COLLO: 3,
	LABEL_PACKAGE: 4,
	RETURN_ERS: 5,
	RETURN_SPECIAL: 6,
	EXPRESS: 7,
	FULFILMENT: 8
}, r = {
	PENDING_CONCEPT: 1,
	PENDING_REGISTERED: 2,
	ENROUTE_HANDED_TO_CARRIER: 3,
	ENROUTE_SORTING: 4,
	ENROUTE_DISTRIBUTION: 5,
	DELIVERED_AT_CUSTOMS: 6,
	DELIVERED: 7,
	IN_PICKUP_LOCATION: 8,
	PICKED_UP: 9,
	RETURN_SHIPMENT_DELIVERED: 10,
	RETURN_SHIPMENT_IN_PICKUP_LOCATION: 11,
	PRINTED_UNPAID_LABEL: 12,
	CREDIT: 13,
	PRINTED_STAMP: 14,
	PRINTED_EXTERNAL_SHIPMENT: 15,
	EXPIRED: 16,
	CANCELLED: 17,
	PRINTED_UNTRACKED_SHIPMENT: 18,
	DELIVERED_AT_AGREED_LOCATION: 19,
	INACTIVE: 98,
	DELETED: 99,
	CREDIT_REJECTED: 100,
	CREDIT_APPROVED: 101,
	LEGACY_PENDING_CONCEPT: 30,
	LEGACY_PENDING_REGISTERED: 31,
	LEGACY_ENROUTE_HANDED_TO_CARRIER: 32,
	LEGACY_ENROUTE_SORTING: 33,
	LEGACY_ENROUTE_DISTRIBUTION: 34,
	LEGACY_DELIVERED_AT_CUSTOMS: 35,
	LEGACY_DELIVERED: 36,
	LEGACY_IN_PICKUP_LOCATION: 37,
	LEGACY_PICKED_UP: 38
}, i = {
	FALSE: 0,
	TRUE: 1
}, a = {
	PACKAGE: 1,
	MAILBOX: 2,
	UNFRANKED: 3,
	DIGITAL_STAMP: 4,
	PALLET: 5,
	SMALL_PACKAGE: 6,
	ENVELOPE: 7
}, o = {
	RETAIL: "retail",
	LOCKER: "locker",
	POST_OFFICE: "post_office"
}, s = {
	UNKNOWN: 0,
	POST_OFFICE: 1,
	POST_POINT: 2,
	PARCEL_LOCKER: 4,
	CLICK_COLLECT: 8,
	PARCEL_POINT: 16
}, c = {
	COMMERCIAL_GOODS: 1,
	COMMERCIAL_SAMPLE: 2,
	DOCUMENTS: 3,
	GIFT: 4,
	RETURNED_GOODS: 5
}, l = {
	NULL: null,
	PENDING: "pending",
	UNPAID: "unpaid",
	PAID: "paid"
}, u = {
	"": "",
	EUR: "EUR"
}, d = {
	FACEBOOK: "Facebook",
	FLESPAKKET_NL: "Flespakket.nl",
	AMAZON: "Amazon",
	BOL_COM: "Bol.com",
	MY_PARCEL_NL: "MyParcel.nl",
	WIX: "Wix",
	ECWID: "Ecwid",
	EXACT_ONLINE_DE: "Exact Online DE",
	EXACT_ONLINE_NL: "Exact Online NL",
	ETSY: "Etsy"
}, f = {
	NULL: null,
	PENDING: "pending",
	UNPAID: "unpaid",
	PAID: "paid"
}, p = {
	POSTNL: 1,
	BPOST: 2,
	CHEAP_CARGO: 3,
	DPD: 4,
	INSTABOX: 5,
	DHL_CHEAP_CARGO: 6,
	BOL: 7,
	UPS: 8,
	DHL_FOR_YOU: 9,
	DHL_PARCEL_CONNECT: 10,
	DHL_EUROPLUS: 11,
	UPS_STANDARD: 12,
	UPS_EXPRESS_SAVER: 13,
	GLS: 14,
	BRT: 15,
	TRUNKRS: 16,
	INPOST: 17,
	POSTE_ITALIANE: 18,
	SPRING: 19,
	VIA_TIM: 20,
	DHL_FREIGHT: 21
}, m = {
	MYPARCEL: 1,
	FLESPAKKET: 2,
	BELGIE: 3,
	DELIVERY_DUTCH: 4,
	POSTNL_CUSTOMER: 5,
	ITALY: 6
}, h = {
	"": "",
	EUR: "EUR"
}, g = { 400: 400 }, _ = {
	NONE: 0,
	OFFSET: 1,
	ABBREVIATION: 2,
	IDENTIFIER: 3
}, v = {
	MORNING: "morning",
	STANDARD: "standard",
	EVENING: "evening",
	SAME_DAY: "same_day",
	EXPRESS: "express",
	EARLY_MORNING: "early_morning"
}, y = {
	PACKAGE: "package",
	MAILBOX: "mailbox",
	UNFRANKED: "unfranked",
	DIGITAL_STAMP: "digital_stamp",
	PALLET: "pallet",
	SMALL_PACKAGE: "small_package",
	ENVELOPE: "envelope"
}, b = {
	MORNING: 1,
	STANDARD: 2,
	EVENING: 3,
	PICKUP: 4,
	SAME_DAY: 6,
	EXPRESS: 7,
	EARLY_MORNING: 8
}, x = { 406: 406 }, S = {
	SUNDAY: 0,
	MONDAY: 1,
	TUESDAY: 2,
	WEDNESDAY: 3,
	THURSDAY: 4,
	FRIDAY: 5,
	SATURDAY: 6
}, C = {
	MONDAY: 1,
	TUESDAY: 2,
	WEDNESDAY: 3,
	THURSDAY: 4,
	FRIDAY: 5,
	SATURDAY: 6,
	SUNDAY: 7
}, w = { 415: 415 }, T = { 401: 401 }, E = {
	REGISTERED: "registered",
	HANDED_TO_CARRIER: "handed_to_carrier",
	SORTING: "sorting",
	DISTRIBUTION: "distribution",
	DELIVERED: "delivered",
	NULL: null
}, D = {
	ESTIMATED: "estimated",
	EXPECTED: "expected",
	NULL: null
}, ee = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_FREIGHT: "DHL_FREIGHT",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	POSTNL: "POSTNL",
	SPRING: "SPRING",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM"
}, O = {
	PACKAGE: "PACKAGE",
	MAILBOX: "MAILBOX",
	UNFRANKED: "UNFRANKED",
	DIGITAL_STAMP: "DIGITAL_STAMP",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	ENVELOPE: "ENVELOPE"
}, k = {
	MORNING: "MORNING_DELIVERY",
	STANDARD: "STANDARD_DELIVERY",
	EVENING: "EVENING_DELIVERY",
	PICKUP: "PICKUP_DELIVERY",
	SAME_DAY: "SAME_DAY_DELIVERY",
	EXPRESS: "EXPRESS_DELIVERY",
	EARLY_MORNING: "EARLY_MORNING_DELIVERY"
}, A = {
	B2B: "B2B",
	B2C: "B2C"
}, j = {
	POSTNL: 1,
	BPOST: 2,
	CHEAP_CARGO: 3,
	DPD: 4,
	DHL_FOR_YOU: 9,
	DHL_PARCEL_CONNECT: 10,
	DHL_EUROPLUS: 11,
	UPS_STANDARD: 12,
	UPS_EXPRESS_SAVER: 13,
	GLS: 14,
	BRT: 15,
	TRUNKRS: 16,
	INPOST: 17,
	POSTE_ITALIANE: 18,
	SPRING: 19,
	VIA_TIM: 20,
	DHL_FREIGHT: 21
}, M = {
	EXPRESS: "EXPRESS",
	FULFILMENT: "FULFILMENT",
	LABEL_PACKAGE: "LABEL_PACKAGE",
	MULTI_COLLO: "MULTI_COLLO",
	RETURN: "RETURN",
	RETURN_ERS: "RETURN_ERS",
	RETURN_SPECIAL: "RETURN_SPECIAL",
	STANDARD: "STANDARD"
}, N = {
	1: 1,
	2: 2,
	3: 3,
	4: 4,
	5: 5,
	6: 6,
	7: 7
}, P = {
	LABEL_DOWNLOAD: "LABEL_DOWNLOAD",
	FIRST_SCAN: "FIRST_SCAN",
	RETURN: "RETURN"
}, F = {
	POSTNL: "1",
	BPOST: "2",
	CHEAP_CARGO: "3",
	DPD: "4",
	INSTABOX: "5",
	DHL_CHEAP_CARGO: "6",
	BOL: "7",
	UPS: "8",
	DHL_FOR_YOU: "9",
	DHL_PARCEL_CONNECT: "10",
	DHL_EUROPLUS: "11",
	UPS_STANDARD: "12",
	UPS_EXPRESS_SAVER: "13",
	GLS: "14",
	BRT: "15",
	TRUNKRS: "16",
	INPOST: "17",
	POSTE_ITALIANE: "18",
	SPRING: "19",
	VIA_TIM: "20",
	DHL_FREIGHT: "21"
}, I = {
	POSTNL: "postnl",
	BPOST: "bpost",
	CHEAP_CARGO: "cheapcargo",
	DPD: "dpd",
	INSTABOX: "instabox",
	DHL_CHEAP_CARGO: "dhl",
	BOL: "bol.com",
	UPS: "ups",
	DHL_FOR_YOU: "dhlforyou",
	DHL_PARCEL_CONNECT: "dhlparcelconnect",
	DHL_EUROPLUS: "dhleuroplus",
	UPS_STANDARD: "upsstandard",
	UPS_EXPRESS_SAVER: "upsexpresssaver",
	GLS: "gls",
	BRT: "brt",
	TRUNKRS: "trunkrs",
	INPOST: "inpost",
	POSTE_ITALIANE: "posteitaliane",
	SPRING: "spring",
	VIA_TIM: "viatim",
	DHL_FREIGHT: "dhlfreight"
}, L = {
	FALSE: !1,
	TRUE: !0,
	0: 0,
	1: 1,
	2: "0",
	12: "1",
	FALSE2: "false",
	TRUE2: "true",
	OFF: "off",
	ON: "on",
	NO: "no",
	YES: "yes",
	"": "",
	NULL: null
}, R = {
	MORNING: "1",
	STANDARD: "2",
	EVENING: "3",
	PICKUP: "4",
	SAME_DAY: "6",
	EXPRESS: "7",
	EARLY_MORNING: "8"
}, z = {
	A4: "A4",
	A6: "A6"
}, B = {
	ASC: "ASC",
	DESC: "DESC"
}, V = {
	MYPARCEL: "myparcel",
	FLESPAKKET: "flespakket",
	BELGIE: "belgie",
	DELIVERY_DUTCH: "delivery_dutch",
	POSTNL_CUSTOMER: "postnl_customer",
	ITALY: "italy"
}, H = {
	MYPARCEL: "1",
	FLESPAKKET: "2",
	BELGIE: "3",
	DELIVERY_DUTCH: "4",
	POSTNL_CUSTOMER: "5",
	ITALY: "6"
}, U = {
	TOP_LEFT_QUADRANT: 1,
	TOP_RIGHT_QUADRANT: 2,
	BOTTOM_LEFT_QUADRANT: 3,
	BOTTOM_RIGHT_QUADRANT: 4
}, W = {
	AMOUNT: "amount",
	CREATED: "created",
	CREATED_BY: "created_by",
	CURRENCY: "currency",
	DROP_OFF_POINT: "drop_off_point",
	HIDDEN: "hidden",
	ID: "id",
	MARK_DELIVERED: "mark_delivered",
	MODIFIED: "modified",
	MODIFIED_BY: "modified_by",
	ORDER_SHIPMENT_IDENTIFIER: "order_shipment_identifier",
	PARENT_ID: "parent_id",
	RECIPIENT: "recipient",
	REFERENCE_IDENTIFIER: "reference_identifier",
	SENDER: "sender",
	SHIPMENT_TYPE: "shipment_type",
	SHOP_ID: "shop_id",
	STATUS: "status",
	TRANSACTION_STATUS: "transaction_status"
}, G = { 1: 1 }, K = { 2: 2 }, q = { 6: 6 }, J = {
	1: 1,
	2: 2,
	4: 4,
	9: 9,
	10: 10,
	11: 11,
	14: 14,
	15: 15,
	17: 17,
	18: 18
}, Y = {
	RETAIL: "RETAIL",
	LOCKER: "LOCKER",
	POST_OFFICE: "POST_OFFICE"
}, X = {
	ASC: "asc",
	DESC: "desc"
}, Z = {
	[o.RETAIL]: Y.RETAIL,
	[o.LOCKER]: Y.LOCKER,
	[o.POST_OFFICE]: Y.POST_OFFICE
}, Q = (e) => Z[e], $ = {
	[Y.RETAIL]: o.RETAIL,
	[Y.LOCKER]: o.LOCKER,
	[Y.POST_OFFICE]: o.POST_OFFICE
}, te = (e) => $[e], ne = {
	additionalInsurance: "additionalInsurance",
	deliverAtPostalPoint: "deliverAtPostalPoint",
	freshFood: "freshFood",
	frozen: "frozen",
	hideSender: "hideSender",
	insurance: "insurance",
	noTracking: "noTracking",
	oversizedPackage: "oversizedPackage",
	priorityDelivery: "priorityDelivery",
	printReturnLabelAtDropOff: "printReturnLabelAtDropOff",
	requiresCashOnDelivery: "requiresCashOnDelivery",
	recipientOnlyDelivery: "recipientOnlyDelivery",
	requiresAgeVerification: "requiresAgeVerification",
	requiresReceiptCode: "requiresReceiptCode",
	requiresSignature: "requiresSignature",
	returnOnFirstFailedDelivery: "returnOnFirstFailedDelivery",
	sameDayDelivery: "sameDayDelivery",
	saturdayDelivery: "saturdayDelivery",
	scheduledCollection: "scheduledCollection",
	tracked: "tracked"
};
//#endregion
export { W as $, O as A, N as B, U as C, G as D, a as E, J as F, d as G, c as H, b as I, r as J, E as K, k as L, l as M, n as N, K as O, p as P, z as Q, i as R, s as S, Y as T, D as U, A as V, v as W, I as X, F as Y, R as Z, L as _, V as a, ee as b, S as c, e as d, y as et, g as f, w as g, x as h, m as i, M as j, q as k, C as l, t as m, Q as n, H as o, T as p, f as q, te as r, h as s, ne as t, X as tt, _ as u, B as v, o as w, P as x, j as y, u as z };
